// Normalizes user input into a slug for use as the /chapters doc ID.
export const slugifyChapter = (value) => (value || "")
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9\s-]/g, "")
  .replace(/\s+/g, "-")
  .replace(/-+/g, "-")
  .replace(/^-+|-+$/g, "");
